import { type CardDataClass, cardSuits, cardType } from "@durak/common"
import { useDimension } from "@/shared/store/dimensions-store"
import clsx from "clsx"
import { useMemo } from "react"

export interface CardProps {
  card: CardDataClass
  type: "inFan" | "main"
  scaleSize?: number
  disabled?: boolean
}

const fullWidth = 2990
const fullHeight = 1380
export const cardWidth = 230
export const cardHeight = 345

export const Card = ({
  card,
  type,
  scaleSize,
  disabled = false,
}: CardProps) => {
  const { cardScale } = useDimension((state) => state.dimension)

  const initialScale = useMemo(() => {
    return scaleSize
      ? scaleSize
      : Math.round(cardScale * (type === "main" ? 0.451 : 0.7) * 100) / 100
  }, [scaleSize, cardScale, type])

  const maxHeight = useMemo(() => {
    return type === "main" ? 110 : Number.POSITIVE_INFINITY
  }, [type])
  const maxWidth = useMemo(() => {
    return type === "main" ? 70 : Number.POSITIVE_INFINITY
  }, [type])

  const calculatedHeight = cardHeight * initialScale
  const calculatedWidth = cardWidth * initialScale

  const exceedsMax = calculatedHeight > maxHeight || calculatedWidth > maxWidth

  const scale = useMemo(() => {
    return exceedsMax
      ? Math.round(
          Math.min(maxHeight / cardHeight, maxWidth / cardWidth) * 1000
        ) / 1000
      : initialScale
  }, [exceedsMax, maxHeight, maxWidth, cardHeight, cardWidth, initialScale])

  const typeIndex = useMemo(() => {
    return cardType.indexOf(card.cardType)
  }, [cardType, card.cardType])
  const suitIndex = useMemo(() => {
    return cardSuits.indexOf(card.cardSuit)
  }, [cardSuits, card.cardSuit])
  const xPos = -typeIndex * cardWidth
  const yPos = -suitIndex * cardHeight

  return (
    <div
      className={clsx(
        "bg-origin-border",
        type === "inFan"
          ? "rounded-[7%]"
          : "rounded-[7%] max-h-[105px] max-w-[70px]"
      )}
      style={{
        backgroundImage: `url(/customs/cards/deck/${card.custom})`,
        backgroundPosition: `${xPos * scale}px ${yPos * scale}px`,
        backgroundSize: `${fullWidth * scale}px ${fullHeight * scale}px`,
        height: `${Math.min(calculatedHeight, maxHeight)}px`,
        width: `${Math.min(calculatedWidth, maxWidth)}px`,
        filter: disabled ? "brightness(0.5)" : "none",
      }}
    />
  )
}
